"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialService = void 0;
const api_1 = require("./api");
const PATH = '/profile/api/social';
class SocialService {
    static async getTwitterOauthToken(oauthVerifier, oauthToken) {
        try {
            return await api_1.API.get({
                url: `${PATH}/twitter/verify?oauth_verifier=${oauthVerifier}&oauth_token=${oauthToken}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getTwitterRequestToken() {
        try {
            return await api_1.API.get({
                url: `${PATH}/twitter/`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getInstagramRequestToken(code, redirectUrl) {
        try {
            return await api_1.API.get({
                url: `${PATH}/instagram?code=${code}&redirectURL=${redirectUrl}`
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.SocialService = SocialService;
//# sourceMappingURL=social-service.js.map